import React from 'react';
import { Flame, TrendingUp } from 'lucide-react';
import { CompactCountdown } from './ui/CompactCountdown';
import { PricingChoice } from './ui/PricingChoice';
import { FadeIn } from './ui/FadeIn';
export function PricingSection() {
  const capacityPercent = 68;
  return <section id="pricing" className="py-10 md:py-24 relative scroll-mt-10" data-id="element-194">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-195">
        {/* Compact Urgency Banner */}
        <FadeIn className="mb-5 md:mb-8 max-w-2xl mx-auto" data-id="element-196">
          <div className="relative bg-gradient-to-br from-brand-card to-brand-dark border border-brand-orange/40 rounded-2xl p-3 md:p-5 shadow-[0_0_30px_rgba(255,107,26,0.12)] overflow-hidden" data-id="element-197">
            <div className="absolute -top-12 -right-12 w-40 h-40 bg-brand-orange/10 rounded-full blur-3xl pointer-events-none" data-id="element-198" />

            {/* Top row */}
            <div className="flex items-center justify-between mb-3 relative z-10 flex-wrap gap-2" data-id="element-199">
              <div className="flex items-center gap-2" data-id="element-200">
                <span className="relative flex h-2.5 w-2.5" data-id="element-201">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-202" />
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-203" />
                </span>
                <span className="text-[10px] md:text-xs font-bold tracking-widest uppercase text-red-400" data-id="element-204">
                  Oferta en vivo
                </span>
              </div>
              <div className="flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 px-2 py-0.5 rounded-md" data-id="element-205">
                <TrendingUp className="w-3 h-3 text-red-400" data-id="element-206" />
                <span className="text-[10px] md:text-xs font-bold text-red-400 tracking-wider" data-id="element-207">
                  +$8.000 DESPUÉS
                </span>
              </div>
            </div>

            {/* Countdown row */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 relative z-10 mb-4" data-id="element-208">
              <div className="flex items-center gap-2" data-id="element-209">
                <Flame className="w-5 h-5 text-brand-orange shrink-0" data-id="element-210" />
                <div data-id="element-211">
                  <p className="font-display text-sm md:text-base leading-tight tracking-wide" data-id="element-212">
                    LANZAMIENTO{' '}
                    <span className="text-brand-orange" data-id="element-213">TERMINA EN</span>
                  </p>
                  <p className="text-[10px] md:text-xs text-brand-muted" data-id="element-214">
                    Y no vuelve a bajar
                  </p>
                </div>
              </div>
              <CompactCountdown data-id="element-215" />
            </div>

            {/* Capacity bar */}
            <div className="relative z-10 border-t border-brand-border/60 pt-3" data-id="element-216">
              <div className="flex items-center justify-between mb-1.5" data-id="element-217">
                <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-brand-muted" data-id="element-218">
                  Cupos restantes
                </span>
                <span className="text-[10px] md:text-xs font-bold text-brand-orange" data-id="element-219">
                  {capacityPercent}% TOMADOS
                </span>
              </div>
              <div className="h-2 bg-brand-dark border border-brand-border rounded-full overflow-hidden relative" data-id="element-220">
                <div className="h-full bg-gradient-to-r from-brand-orange to-red-500 rounded-full relative transition-all duration-1000" style={{
                width: `${capacityPercent}%`
              }} data-id="element-221">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-222" />
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Heading */}
        <FadeIn delay={0.1} className="text-center mb-5 md:mb-8" data-id="element-223">
          <h3 className="text-xl md:text-3xl mb-1" data-id="element-224">
            Elegí tu{' '}
            <span className="text-brand-orange" data-id="element-225">
              Calistenia Avanzada Resuelta
            </span>
          </h3>
          <p className="text-xs md:text-sm text-brand-muted" data-id="element-226">
            Ambas opciones incluyen los 6 bonos estratégicos completos
          </p>
        </FadeIn>

        {/* Pricing Choice */}
        <FadeIn delay={0.2} data-id="element-227">
          <PricingChoice data-id="element-228" />
        </FadeIn>
      </div>
    </section>;
}